<template>
	<div>
		<!-- 小标题一 -->
		<el-row class="title" type="flex">
			<img src="@/assets/img/tag.png" alt="">
			<span class="title_text">场所标准地址</span>
		</el-row>

		<div>
			<!-- 表格展示一 -->
			<el-descriptions border class="form">
				<el-descriptions-item label="详细地址" :labelStyle="{ 'width': '180px' }">
					{{ list.hi_dzmc }}
				</el-descriptions-item>
			</el-descriptions>
			<template v-if="is_ybss == 1">
				<!-- 小标题二 -->
				<el-row class="title" type="flex">
					<img src="@/assets/img/tag.png" alt="">
					<span class="title_text">房屋基本信息</span>
				</el-row>
				<!-- 表格展示二 -->
				<el-descriptions border class="form" :column="3" labelClassName="labelWidth" contentClassName="contentStyle">
					<el-descriptions-item label="房屋类别">
						{{ list.hi_fwlb | fwlbFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="房屋性质">
						{{ list.hi_fwxz | fwxzFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="房屋用途">
						{{ list.hi_fwyt | fwytFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="房屋现状">
						{{ list.hi_fwzt | fwztFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="房屋面积">
						{{ list.hi_fwmj ? `${list.hi_fwmj}㎡` : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="房屋间数">
						{{ list.hi_fwjs ? `${list.hi_fwjs}间` : '' }}
					</el-descriptions-item>
					<el-descriptions-item label="产权证号">
						{{ list.hi_cqzh }}
					</el-descriptions-item>
					<el-descriptions-item label="房屋结构">
						{{ list.hi_fwjg | fwjgFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="是否出租">
						{{ list.hi_sfcz | sfFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="是否注销">
						{{ list.hi_sfzx | sfFilter }}
					</el-descriptions-item>
					<el-descriptions-item label="房主/托管人">
						{{ fzAndzh }}
					</el-descriptions-item>
				</el-descriptions>
				<!-- 如果是房主显示 -->
				<template v-if="list.hi_is_fz">
					<el-row class="title" type="flex">
						<img src="@/assets/img/tag.png" alt="">
						<span class="title_text">房主信息</span>
					</el-row>
					<el-descriptions border class="form" :column="3" labelClassName="labelWidth" contentClassName="contentStyle">
						<el-descriptions-item label="证件类型">
							{{ list.hi_fz_zjlx | zjlxFilter }}
						</el-descriptions-item>
						<el-descriptions-item label="证件号码">
							{{ list.hi_fz_zjhm }}
						</el-descriptions-item>
						<el-descriptions-item label="房主姓名">
							{{ list.hi_fz_xm }}
						</el-descriptions-item>
						<el-descriptions-item label="联系方式">
							{{ list.hi_fz_lxdh }}
						</el-descriptions-item>
					</el-descriptions>

				</template>
				<!-- 如果是托管人显示 -->
				<template v-if="list.hi_is_tgr">
					<el-row class="title" type="flex">
						<img src="@/assets/img/tag.png" alt="">
						<span class="title_text">托管人信息</span>
					</el-row>
					<el-descriptions border class="form" :column="3" labelClassName="labelWidth" contentClassName="contentStyle">
						<el-descriptions-item label="证件类型">
							{{ list.hi_tgr_zjlx | zjlxFilter }}
						</el-descriptions-item>
						<el-descriptions-item label="证件号码">
							{{ list.hi_tgr_zjhm }}
						</el-descriptions-item>
						<el-descriptions-item label="托管人姓名">
							{{ list.hi_tgr_xm }}
						</el-descriptions-item>
						<el-descriptions-item label="联系方式">
							{{ list.hi_tgr_lxdh }}
						</el-descriptions-item>
						<el-descriptions-item label="与房主关系">
							{{ list.hi_tgr_yfzgx | yfzgxFilter }}
						</el-descriptions-item>
					</el-descriptions>
				</template>
			</template>

		</div>

	</div>
</template>

<script>
import { filtersInfo, lists } from '@/utils/dictionary.js'
let that
export default {
	name: 'CheckStandardVue',
	props: {
		list: {
			require: true
		},
		is_ybss: {
			require: true
		}
	},
	data() {
		return {
			fzAndzh: '',
			copyList: [],
			fwlbList: [],//房屋类别字典 
			fwxzList: [],//房屋性质字典 
			fwytList: [],//房屋用途字典 
			fwztList: [],//房屋现状字典 
			fwjgList: [],//房屋结构字典 
			sfList: [],//是否注销字典 
			zjlxList: [],//证件类型字典 
			yfzgxList: [],//房主关系字典 
		}
	},
	beforeCreate() {
		that = this
	},
	created() {

	},
	mounted() { this.info() },
	watch: {
		list(val) {
			console.log(val.hi_is_fz);
			const hi_is_fz = val.hi_is_fz
			const hi_is_tgr = val.hi_is_tgr
			if (!hi_is_fz && !hi_is_tgr) {
				this.fzAndzh = ''
			} else if (!hi_is_fz && hi_is_tgr) {
				this.fzAndzh = '托管人'
			} if (hi_is_fz && !hi_is_tgr) {
				this.fzAndzh = '房主'
			} if (hi_is_fz && hi_is_tgr) {
				this.fzAndzh = '房主/托管人'
			}
		},
	},
	methods: {
		async info() {
			// 获取字典
			this.fwlbList = lists['FWLB']
			this.fwxzList = lists['FWXZH']
			this.fwytList = lists['FWYT']
			this.fwztList = lists['FWXZ']
			this.fwjgList = lists['FWJG']
			this.zjlxList = lists['ZJLX']
			this.yfzgxList = lists['YBRGX']
			this.sfList = lists['SF']
		},
		goBack() { //点击返回
			this.$router.back(-1)
		},
		revise() { // 点击修改跳转
			this.$router.push('/enterprise_information/set_standard')
		}
	},
	filters: {
		fwlbFilter(val) {
			if (val != 0 && !val) return ''
			return filtersInfo(that.fwlbList, val)
		},
		fwxzFilter(val) {
			if (val != 0 && !val) return ''
			return filtersInfo(that.fwxzList, val)
		},
		fwytFilter(val) {
			if (val != 0 && !val) return ''
			return filtersInfo(that.fwytList, val)
		},
		fwztFilter(val) {
			if (val != 0 && !val) return ''
			return filtersInfo(that.fwztList, val)
		},
		fwjgFilter(val) {
			if (val != 0 && !val) return ''
			return filtersInfo(that.fwjgList, val)
		},
		sfFilter(val) {
			return filtersInfo(that.sfList, val)
		},
		zjlxFilter(val) {
			return filtersInfo(that.zjlxList, val)
		},
		yfzgxFilter(val) {
			console.log(val);
			return filtersInfo(that.yfzgxList, val)
		},

	}
}
</script>
<style lang="less" scoped>
.title_text {
	font-size: 18px;
	line-height: 30px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #6345D5;
}

// /deep/ .el-descriptions-item__cell {
// 	width: 315px;
// }

.form {
	margin: 15px 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-size: 14 px;
	font-family: Source Han Sans SC;
	font-weight: 500;
	color: #6B6C78;
}
</style>